module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "chapter001"
    }
  }, [_c('h1', {
    staticClass: "chapter-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page-3"
    }
  }), _c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HE PAST IS A VERY BAD PLACE.")]), _vm._v(" I"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("T IS NOT GOOD TO GO")]), _vm._v(" there. Not alone. Not like this. “Take a deep breath.” They’re always telling me to take a deep breath. But that deep breath does not come.")]), _vm._v(" "), _c('p', [_vm._v("Somewhere along the line, something went wrong.")]), _vm._v(" "), _c('p', [_vm._v("These words were supposed to have led to more words, to the beginning of what I cannot bring myself to tell.")]), _vm._v(" "), _c('p', [_vm._v("Now, having got up, poured myself a drink, lit a cigarette, and stood awhile at the window—seeing night and rain, feeling nothing—I look at those words and realize that I’ve just written my autobiography, the story of my life. From beginning to end, that’s it. Somewhere along the line, something went wrong. There’s really nothing more to it than that.")]), _vm._v(" "), _c('p', [_vm._v("But that’s the easy way out, the easy way out of saying what I cannot bring myself to say. Yes, a lot went wrong. There were a lot of wrong turns. But this one. This one.")]), _vm._v(" "), _c('p', [_vm._v("Let me drink.")]), _vm._v(" "), _c('p', [_vm._v("The label on this bottle has a lot of words on it. Some of them are invisible: lies, truth, destiny, darkness, loss, shame, guilt, the sound and fury of the idiot’s every delusion, sickness unto death of body and of soul. And courage for the coward. I have read and retched them all, these hidden things upon that label. They define what is in the bottle, and what is within me.")]), _vm._v(" "), _c('p', [_vm._v("Courage for the coward. Yes, let me drink, so that I can say "), _c('a', {
    attrs: {
      "id": "page-4"
    }
  }), _vm._v("what I cannot. Even if in the end I let the flames consume it, and can then return quietly to my lies. This thought goes well with that coward’s courage that I seek.")]), _vm._v(" "), _c('p', [_vm._v("But can there be any returning? Any returning to anything? Now? From here, from this final somewhere? This final somewhere of endless wrong somethings and endless wrong turns?")]), _vm._v(" "), _c('p', [_vm._v("Enough. Just drink. There, yes, that’s better, that’s it. Just drink and the words will come.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec8694a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter001.vue
// module id = 72
// module chunks = 0